import { create } from 'zustand';
import { Movement, EstimatedTime, DefaultSchedule } from '../types/movement';
import { collection, doc, getDoc, getDocs, setDoc, updateDoc } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';
import { usePackagesStore } from './packagesStore';
import { useFlightsStore } from './flightsStore';
import { usePilgrimsStore } from './pilgrimsStore';
import { generateMovements } from '../services/movementService';

type MovementState = {
  movements: Movement[];
  estimatedTimes: EstimatedTime[];
  defaultSchedules: DefaultSchedule[];
  loading: boolean;
  error: string | null;
  fetchMovements: () => Promise<void>;
  updateEstimatedTimes: (times: EstimatedTime[]) => Promise<void>;
  updateDefaultSchedules: (schedules: DefaultSchedule[]) => Promise<void>;
};

export const useMovementStore = create<MovementState>((set, get) => ({
  movements: [],
  estimatedTimes: [
    { id: '1', from: 'مطار جدة', to: 'فندق في مكة', hours: 2 },
    { id: '2', from: 'مطار جدة', to: 'فندق في المدينة', hours: 5 },
    { id: '3', from: 'مطار المدينة', to: 'فندق في مكة', hours: 4 },
    { id: '4', from: 'مطار المدينة', to: 'فندق في المدينة', hours: 1 },
    { id: '5', from: 'فندق في مكة', to: 'فندق في المدينة', hours: 7 },
    { id: '6', from: 'فندق في المدينة', to: 'فندق في مكة', hours: 7 },
    { id: '7', from: 'فندق في مكة', to: 'فندق في مكة', hours: 1 },
    { id: '8', from: 'فندق في المدينة', to: 'فندق في المدينة', hours: 1 },
    { id: '9', from: 'المخيم', to: 'فندق في مكة', hours: 1 },
    { id: '10', from: 'فندق في مكة', to: 'المخيم', hours: 1 }
  ],
  defaultSchedules: [
    { id: '1', name: 'موعد الذهاب الى المخيم', date: '2025-01-10' },
    { id: '2', name: 'موعد الرجوع من المخيم', date: '2025-01-15' },
    { id: '3', name: 'وقت تحرك الفنادق', time: '12:00' },
    { id: '4', name: 'وقت التحرك من المخيم', time: '12:00' }
  ],
  loading: false,
  error: null,

  fetchMovements: async () => {
    set({ loading: true, error: null });
    try {
      // Get data from other stores
      const packages = usePackagesStore.getState().packages;
      const flights = useFlightsStore.getState().flights;
      const pilgrims = usePilgrimsStore.getState().pilgrims;

      // Generate movements based on real data
      const movements = generateMovements(packages, flights, pilgrims);
      
      set({ movements, loading: false });
    } catch (error: any) {
      console.error('Error fetching movements:', error);
      set({ error: error.message, loading: false });
    }
  },

  updateEstimatedTimes: async (times: EstimatedTime[]) => {
    try {
      const docRef = doc(firestore, 'Settings', 'estimatedTimes');
      await setDoc(docRef, { times });
      set({ estimatedTimes: times });
    } catch (error: any) {
      console.error('Error updating estimated times:', error);
      throw error;
    }
  },

  updateDefaultSchedules: async (schedules: DefaultSchedule[]) => {
    try {
      const docRef = doc(firestore, 'Settings', 'defaultSchedules');
      await setDoc(docRef, { schedules });
      set({ defaultSchedules: schedules });
    } catch (error: any) {
      console.error('Error updating default schedules:', error);
      throw error;
    }
  }
}));